export default __webpack_public_path__ + "static/vision-f0ff6402b17454accf47f5eae31cb4c7.jpg";